<template>
	<div>
		<v-layout>
			<v-spacer></v-spacer>
			<v-tooltip bottom v-if="excel">
				<v-btn @click="excelClick()" icon slot="activator">
					<v-icon small>fa-file-excel</v-icon>
				</v-btn>
				<span>{{$t('tooltips.excel')}}</span>
			</v-tooltip>
			<v-tooltip bottom v-if="searchableHeaders.hidden.length != 0">
				<v-btn @click="toggleFilter" icon slot="activator">
					<v-icon small>fa-filter</v-icon>
				</v-btn>
				<span>{{$t('tooltips.filter')}}</span>
			</v-tooltip>
		</v-layout>
		<v-expand-transition>
			<v-layout row v-if="filter" wrap>
				<v-flex pa-1>
					<v-sheet class="pa-3" color="green lighten-5">
						<v-layout row wrap>
							<v-flex :key="key" class="pa-1" lg3 md4 sm6
									v-for="(header, key) in searchableHeaders.hidden">
								<div class="filter-container">
									<FilterField
										:filterType="'hidden'" :name="header.value" :text="header.text"
										:type="header.type"
										@changes="reloadData" v-model="request.search"></FilterField>
								</div>
							</v-flex>
						</v-layout>
					</v-sheet>
				</v-flex>
			</v-layout>
		</v-expand-transition>

		<v-layout v-if="searchableHeaders.above.length != 0">
			<v-flex :key="key" lg3 md4 sm6 v-for="(header, key) in searchableHeaders.above" class="pa-1">
				<div class="filter-container">
					<FilterField
						:filterType="'above'" :name="header.value" :text="header.text" :type="header.type"
						@changes="reloadData"
						v-model="request.search"></FilterField>
				</div>
			</v-flex>
		</v-layout>

		<v-data-table
			:class="{'data-table': true, 'data-table-fixed': $props.fixed}"
			:disable-initial-sort="true"
			:headers="$props.headers"
			:items="displayItems"
			:must-sort="true"
			:no-data-text="$t('labels.noResults')"
			:no-results-text="$t('labels.noResults')"
			:pagination.sync="request.pagination"
			:rows-per-page-items="rowsPerPage"
			:rows-per-page-text="$t('labels.rowsPerPage')"
			:total-items="$props.total"
		>
			<template #items="props">
				<slot name="row" v-bind:item="props.item" v-if="props.item.filterRow !== true"></slot>
				<template v-if="props.item.filterRow === true">
					<td :key="key" v-for="(header, key) in $props.headers">
						<template v-if="header.searchable === 'inner'">
							<FilterField
								:filterType="'inner'" :name="header.value" :text="header.text"
								:type="header.type" @changes="reloadData"
								v-model="request.search"></FilterField>
						</template>
						<template v-if="header.searchable !== 'inner'">

						</template>
					</td>
				</template>
			</template>
			<template #pageText="props">
				{{ props.pageStart }} - {{ props.pageStop }} {{ $t('labels.of') }} {{ props.itemsLength }}
			</template>
			<template #footer>
				<slot name="footer"></slot>
			</template>
		</v-data-table>

	</div>
</template>

<script>
	import FilterField from "./FilterField";

	export default {
		name: "DataTable",
		components: {FilterField},
		props: ['headers', 'items', 'total', 'sort', 'excel', 'fixed', 'additionalFilters'],
		data: function () {
			return {
				rowsPerPage: [15, 50, 100, {"text": this.$t('labels.all'), "value": -1}],
				request: {
					pagination: {},
					search: {}
				},
				filter: false
			}
		},
		computed: {
			displayItems() {
				let items = this.$props.items;
				if (this.searchableHeaders.inner.length != 0) {
					let filterRow = {
						filterRow: true
					};
					items.unshift(filterRow);
				}
				return items;
			},
			searchableHeaders() {
				let headers = {
					hidden: [],
					above: [],
					inner: []
				};
				for (let field of this.$props.headers) {
					if (field.searchable !== false) {
						headers[field.searchable].push(field);
					}
				}

				if ((typeof this.$props.additionalFilters !== 'undefined')) {
					for (let field of this.$props.additionalFilters) {
						headers[field.searchable].push(field);
					}
				}
				return headers;
			}
		},
		watch: {
			'request.pagination': {
				handler: function () {
					this.reloadData();
				},
				deep: true
			}
		},
		methods: {
			reloadData() {
				this.$emit('reload', this.request);
			},
			resetFilter() {
				for (let field of this.$props.headers) {
					if (field.type == 'string') {
						this.request.search[field.value] = '';
					}
					if (field.type == 'date_range') {
						this.request.search[field.value + '_from'] = null;
						this.request.search[field.value + '_to'] = null;
					}
					if (field.type == 'price_range') {
						this.request.search[field.value + '_from'] = null;
						this.request.search[field.value + '_from_term'] = false;
						this.request.search[field.value + '_to'] = null;
						this.request.search[field.value + '_to_term'] = false;
					}
					if (field.type.includes('dropdown')) {
						this.request.search[field.value] = null;
					}
					if (field.type == 'boolean') {
						this.request.search[field.value] = null;
					}
					if (field.type == 'boolean_yes') {
						this.request.search[field.value] = true;
					}
					if (field.type.includes('tags')) {
						this.request.search[field.value] = [];
					}
					if (field.type.includes('multiple')) {
						this.request.search[field.value] = [];
					}
				}
			},
			retoggleFilter() {
				this.toggleFilter();
				this.$nextTick(() => {
					this.toggleFilter();
				});
			},
			toggleFilter() {
				this.filter = !this.filter;
				if (!this.filter) {
					this.resetFilter();
					this.reloadData();
				}
			},
			changeSort(column) {
				if (this.request.pagination.sortBy === column) {
					this.request.pagination.descending = !this.request.pagination.descending
				} else {
					this.request.pagination.sortBy = column
					this.request.pagination.descending = false
				}
			},
			excelClick() {
				this.$emit('excel', this.request);
			}
		},
		mounted() {
			this.resetFilter();
		}
	}
</script>

<style scoped>
	>>> .data-table .v-table {
		background: transparent !important;
	}

	>>> .data-table .v-table .v-datatable__actions {
		background: transparent !important;
	}

	>>> tfoot tr td {
		font-size: 13px;
		font-weight: bold;
	}

	>>> .data-table-fixed table {
		table-layout: fixed;
	}

	>>> .min-w-100 {
		min-width: 100px !important;
	}

	.filter-container {
		background-color: #F8F8F8;
		padding: 20px;
	}
</style>
